<template>
  <div>
    <title>申请开票</title>
    <ApplyInvoicePage></ApplyInvoicePage>

  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
  name: 'ApplyForInvoice',
  data () {
    return {
    }
  },
  components: {
    ApplyInvoicePage: resolve => require(["@/components/InvoiceManage/ApplyInvoicePage.vue"], resolve),// 申请开票组件
  },
  watch: {
  },
  methods: {
  },
  created() {
    
  },
  mounted () {
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/InvoiceManage/InvoiceApplyList.vue